import { FIND_A_WAREHOUSE_DEVELOPEMENT_KEY } from "../../../../utils/warehouses/warehouseDrawer.constants.js";
const COMPONENT_NAME = "FindAWarehouseForm";
const DATA_TEST_ID = `${COMPONENT_NAME}-all-${FIND_A_WAREHOUSE_DEVELOPEMENT_KEY}`;
const INPUT_ID = "find-a-warehouse-popover-search-field";
const LABEL_ID = "find-a-warehouse-label";
const TITLE_ID = "findawarehouse-title";
export {
  COMPONENT_NAME,
  DATA_TEST_ID,
  INPUT_ID,
  LABEL_ID,
  TITLE_ID
};
